import { PiWarningFill } from "react-icons/pi";
import { COLOR_PRIMARY_BLACK } from "./../../styleConfig";
import styled from "styled-components";
import {
  COLOR_BACKGROUND,
  COLOR_DASHBOARD_BACKGROUND,
  MOBILE_WIDTH,
} from "../../config";

export const MainContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const RowWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  height: fit-content;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const CalendarLabel = styled.p`
  color: ${COLOR_PRIMARY_BLACK};
  font-weight: 400;
  font-size: 14px;
`;

export const RowContainer = styled.div`
  width: 100%;
  display: flex;
  max-width: 100%;
  gap: 25px;
  justify-content: space-between;
  flex-wrap: wrap;

  & > div {
    max-width: 47%;
  }

  @media (max-width: 800px) {
    & > div {
      min-width: 100%;
    }
  }
`;

export const RadioContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  z-index: 10000;
  top: 70px;
  left: 0;
  width: 100vw;
  height: calc(100vh - 70px);
  background-color: rgba(0, 0, 0, 0.5);
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: ${MOBILE_WIDTH}) {
    width: calc(100vw - 255.99px);
    left: 255.99px;
  }
`;

export const ModalMainContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${COLOR_DASHBOARD_BACKGROUND};
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-radius: 10px;
 
`;

export const WarnIconContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-direction: column;
  border-bottom: 1px solid lightgray;
  padding-bottom: 10px;
`;

export const WarnIcon = styled(PiWarningFill)`
  font-size: 100px;
  color: #f2c94c;
`;

export const WarnLabel = styled.p`
  font-size: 13px;
  color: #f2c94c;
  margin-top: -15px;
`;

export const ModalListContainer = styled.ul`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  justify-content: space-between;

`

export const ModalListItem = styled.li`
  font-size: 14px;
  width: 100%;
  color: ${COLOR_PRIMARY_BLACK};
`;
